import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    permissions: [],
    loading: false,
    error: null
  }),

  actions: {
    async fetchPermissions(roleId) {
      if (!roleId) {
        this.error = '無法獲取權限：roleId 為空';
        return;
      }

      this.loading = true;
      this.error = null;
      try {
        const response = await useHttp().get(`/api/admin/member/role-info?id=${roleId}`);
        if (response.data.success) {
          const modulePermissions = response.data?.role?.module_permissions || [];
          const permissionMap = new Map();

          const upsertPermission = (entry = {}, fallbackPermission) => {
            const name = entry?.name?.trim?.();
            if (!name) return;

            const rawPermission = entry.permission ?? fallbackPermission;
            if (rawPermission === undefined || rawPermission === null) return;

            permissionMap.set(name, {
              id: entry.id ?? null,
              module_id: entry.id ?? null,
              name,
              enabled: Number(rawPermission) === 1 || rawPermission === true
            });
          };

          const collectTreePermissions = (moduleNode, fallbackPermission) => {
            if (!moduleNode) return;

            upsertPermission(moduleNode, fallbackPermission);

            if (Array.isArray(moduleNode.children) && moduleNode.children.length > 0) {
              moduleNode.children.forEach(child => {
                const nextFallback = moduleNode.permission ?? fallbackPermission;
                collectTreePermissions(child, nextFallback);
              });
            }
          };

          modulePermissions.forEach(item => {
            if (!item) return;

            
            const flatName = item?.module?.name?.trim?.();
            if (flatName) {
              permissionMap.set(flatName, {
                id: item.id ?? null,
                module_id: item.module_id ?? null,
                name: flatName,
                enabled: Number(item.permission) === 1 || item.permission === true
              });
            }

            // 再遞迴攤平 module.children 的樹狀權限
            collectTreePermissions(item.module, item.permission);
          });

          this.permissions = Array.from(permissionMap.values());
        } else {
          this.error = '獲取權限失敗';
        }
      } catch (error) {
        this.error = error.message;
        this.permissions = [];
      } finally {
        this.loading = false;
      }
    },

    hasPermission(moduleName) {
      if (!moduleName) {
        return false;
      }
      
      if (this.permissions.length === 0) {
        return false;
      }

      const permission = this.permissions.find(p => p.name === moduleName.trim());
      return permission ? permission.enabled : false;
    },

    clearPermissions() {
      this.permissions = [];
      this.error = null;
    }
  }
}); 